<div class="m-3 flex flex-col">
  <label class="leading-normal text-justify">
    Dieses Addin funktioniert nur in Kombination mit einem gültigen Ankaadia Account. Wenn Sie noch keinen Account
    haben, buchen sie gerne einen unverbindlichen Demo Termin. <br />
    <a href="https://www.ankaadia.com/demotermin-buchen/" target="_blank"> Demotermin vereinbaren </a>
  </label>
  <new-ui-button label="Login" (click)="login()" class="mt-4 mx-4"></new-ui-button>
</div>
